export const REGIONS_NUMBERS_DICTIONARY = {
  'los-lagos': 10,
  'los-rios': 14,
  antofagasta: 2,
  araucania: 9,
  arica: 15,
  atacama: 3,
  aysen: 11,
  biobio: 8,
  coquimbo: 4,
  magallanes: 12,
  maule: 7,
  metropolitana: 13,
  nuble: 16,
  ohiggins: 6,
  tarapaca: 1,
  valparaiso: 5
}

export const REGIONS_DICTIONARY = {
  1: {
    name: 'Región de Tarapacá',
    slogan: 'Iquique, Región de Tarapacá, Chile',
    source: '/assets/images/regions/tarapaca.jpg',
    value: 'tarapaca'
  },
  2: {
    name: 'Región de Antofagasta',
    slogan: 'La Portada, Región de Antofagasta, Chile',
    source: '/assets/images/regions/antofagasta.jpg',
    value: 'antofagasta'
  },
  3: {
    name: 'Región de Atacama',
    slogan: 'Desierto de Atacama, Región de Atacama, Chile',
    source: '/assets/images/regions/atacama.jpg',
    value: 'atacama'
  },
  4: {
    name: 'Región de Coquimbo',
    slogan: 'La Serena, Región de Coquimbo, Chile',
    source: '/assets/images/regions/coquimbo.jpg',
    value: 'coquimbo'
  },
  5: {
    name: 'Región de Valparaíso',
    slogan: 'Viña del Mar, Región de Valparaíso, Chile',
    source: '/assets/images/regions/valparaiso.jpg',
    value: 'valparaiso'
  },
  6: {
    name: 'Región del Libertador General Bernardo O’Higgins',
    slogan: 'Valle de Apalta, Región del Libertador General Bernardo O’Higgins, Chile',
    source: '/assets/images/regions/ohiggins.jpg',
    value: 'ohiggins'
  },
  7: {
    name: 'Región del Maule',
    slogan: 'Constitución, Región del Maule, Chile',
    source: '/assets/images/regions/maule.jpg',
    value: 'maule'
  },
  8: {
    name: 'Región del Biobío',
    slogan: 'Salto del Laja , Región del Biobío, Chile',
    source: '/assets/images/regions/biobio.jpg',
    value: 'biobio'
  },
  9: {
    name: 'Región de La Araucanía',
    slogan: 'Melipeuco, Región de La Araucanía, Chile',
    source: '/assets/images/regions/araucania.jpg',
    value: 'araucania'
  },
  10: {
    name: 'Región de Los Lagos',
    slogan: 'Saltos de Petrohué, Región de Los Lagos, Chile',
    source: '/assets/images/regions/los-lagos.jpg',
    value: 'los-lagos'
  },
  11: {
    name: 'Región de Aysén del General Carlos Ibáñez del Campo',
    slogan: 'Cochrane, Región de Aysén del General Carlos Ibáñez del Campo, Chile',
    source: '/assets/images/regions/aysen.jpg',
    value: 'aysen'
  },
  12: {
    name: 'Región de Magallanes y la Antártica Chilena',
    slogan: 'Torres del Paine, Región de Magallanes y la Antártica Chilena, Chile',
    source: '/assets/images/regions/magallanes.jpg',
    value: 'magallanes'
  },
  13: {
    name: 'Región Metropolitana de Santiago',
    slogan: 'Santiago, Región Metropolitana de Santiago, Chile',
    source: '/assets/images/regions/metropolitana.jpg',
    value: 'metropolitana'
  },
  14: {
    name: 'Región de Los Ríos',
    slogan: 'Fuerte Niebla, Región de Los Ríos, Chile',
    source: '/assets/images/regions/los-rios.jpg',
    value: 'los-rios'
  },
  15: {
    name: 'Región de Arica y Parinacota',
    slogan: 'Putre, Región de Arica y Parinacota, Chile',
    source: '/assets/images/regions/arica.jpg',
    value: 'arica'
  },
  16: {
    name: 'Región del Ñuble',
    slogan: 'San Nicolás, Región de Ñuble, Chile',
    source: '/assets/images/regions/nuble.jpg',
    value: 'nuble'
  }
}
